<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { Rive, Fit, Layout } from '@rive-app/canvas'

const canvases = ref(['banner2', 'bard', 'boat', 'castle', 'eye', 'eyeaxe', 'feather', 'hand', 'herald', 'photo', 'portal', 'puppet', 'services', 'spinning_crown_hover2'])
const largeCanvases = ref(['visionaries2'])

const statems = ref({})
const bard = ref(null)
const hoverTest = ref(null)

function toggle() {
	console.log(hoverTest.value)
}

onMounted(() => {
	canvases.value.forEach((c) => {
        let stateMachine = c == 'visionaries2' ? 'aboutSM' : 'crownsStateMachine'
		let rive = new Rive({
			canvas: document.querySelector(`.${c}`),
			src: `https://cdn.papercrowns.com/website/rive/${c}.riv`,
			autoplay: true,
            stateMachines: stateMachine
		})
	})

    largeCanvases.value.forEach((c) => {
        let stateMachine = c == 'visionaries2' ? 'aboutSM' : 'crownsStateMachine'
		let rive = new Rive({
			canvas: document.querySelector(`.${c}`),
			src: `https://cdn.papercrowns.com/website/rive/${c}.riv`,
			autoplay: true,
            layout: new Layout({
                fit: Fit.Contain,
            }),
            stateMachines: stateMachine
		})
	})
})
</script>

<template>
	<main>
		<section class="my-28">
			<div class="container">
				<h1 class="mb-5 font-cabazon text-4xl">Rive Debugging</h1>
				<button @click="toggle">Toggle</button>
				<div class="grid grid-cols-3 gap-5">
					<div class="flex flex-col border border-crowns-grey p-5" v-for="canvas in canvases">
						<canvas :class="canvas, 'self-center'" height="512" width="512"></canvas>
						<p class="text-xs uppercase">{{ canvas }}</p>
					</div>
                    <div class="flex flex-col border border-crowns-grey p-5 col-span-3" v-for="canvas in largeCanvases">
						<canvas :class="canvas, 'self-center'" height="1920" width="1920"></canvas>
						<p class="text-xs uppercase">{{ canvas }}</p>
					</div>
				</div>
			</div>
		</section>
	</main>
</template>
